import CountriesData from '@/views/Register/countries';

// Country names stored on users/participants that don't match the entry in
// views/Register/countries (or need a flagpack-specific code).
const ALIASES = {
  'United Kingdom': 'GB-UKM',
  'United States': 'US',
  'South Korea': 'KR',
  'North Korea': 'KP',
  'Czech Republic': 'CZ',
  'Ivory Coast': 'CI',
  'Russia': 'RU',
};

/**
 * Resolves a stored country name (or ISO code) to the ISO code the Flag
 * component expects. Returns null when nothing matches.
 */
export function countryCodeFor(country) {
  if (!country) return null;
  if (ALIASES[country]) return ALIASES[country];
  const found = CountriesData.find(
    (c) => c.name === country || c.code === country || c.name.startsWith(country),
  );
  return found ? found.code : null;
}
